<div class='row no-gutters product-listing'>
    <lynkd-pattern-attribute-bar-graph class="col-12"
        *ngIf='graph === GraphDisplayMode.Bar' [attribute]='attribute'
        [attributeRows]='attributeRows'></lynkd-pattern-attribute-bar-graph>
    <lynkd-pattern-attribute-line-graph class="col-12" *ngIf='graph === GraphDisplayMode.Line'
                                        [attribute]='attribute'
                                        [attributeRows]='attributeRows'></lynkd-pattern-attribute-line-graph>
</div>
